import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';

import { API as API_URL, BACKEND_URL } from '../utils/apiConfig';

export const AuthCallback = () => {
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      const hash = window.location.hash;
      const sessionId = new URLSearchParams(hash.replace('#', '?')).get('session_id');

      if (!sessionId) {
        navigate('/login');
        return;
      }

      try {
        const response = await axios.post(`${API_URL}/oauth/google/exchange`, {
          session_id: sessionId
        });

        const { access_token } = response.data;
        localStorage.setItem('token', access_token);
        axios.defaults.headers.common['Authorization'] = `Bearer ${access_token}`;

        await loginWithToken(access_token);
        // Return user to the page they were on before login, default to home
        const returnPath = sessionStorage.getItem('returnAfterLogin') || '/';
        sessionStorage.removeItem('returnAfterLogin');
        window.history.replaceState(null, '', returnPath);
        navigate(returnPath);
      } catch (err) {
        console.error('OAuth exchange error:', err);
        navigate('/login');
      }
    };

    processSession();
  }, [navigate, loginWithToken]);

  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      height: '100vh', background: '#f8fafc'
    }}>
      <div style={{ textAlign: 'center' }}>
        <div className="animate-spin" style={{
          width: '40px', height: '40px', border: '4px solid #e2e8f0',
          borderTopColor: '#2563eb', borderRadius: '50%', margin: '0 auto 1rem',
          animation: 'spin 1s linear infinite'
        }} />
        <p style={{ color: '#64748b', fontSize: '1rem' }}>Signing in...</p>
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    </div>
  );
};
